export default __webpack_public_path__ + "static/media/m4.e7ab2fbb.png";